{
  "version": 1,
  "asset_id": "88dfa648-213d-4515-ac58-d706f79a6f65",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/88dfa648-213d-4515-ac58-d706f79a6f65/sleeve-ugi-dilated-1448.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/88dfa648-213d-4515-ac58-d706f79a6f65/sleeve-ugi-dilated-1448.jpg",
  "original_filename": "sleeve-ugi-dilated-1448.jpg",
  "size": 148718,
  "content_type": "image/jpeg",
  "created_at": "2026-09-28T01:30:59Z"
}
